<template>
    <div class="copyInt">
        <ValidationObserver class="centerx default-input" ref="form" v-slot="{handleSubmit}">
            <vc-table :maxItems="30" :pagination="false" ref="tables" stripe :tableData="integrations">
                <template v-slot:head>
                    <vs-th>
                        <vs-checkbox v-model="isSelectedAllIntegrations" @input="selectedAllIntegrations()" class="w-full"/>
                    </vs-th>
                    <vs-th>{{ $t('global.Name') }}</vs-th>
                    <vs-th>{{ $t('global.Geo') }}</vs-th>
                    <vs-th>{{ $t('global.Model') }}</vs-th>
                </template>

                <template v-slot:content="{content}">
                    <vs-td>
                        <vs-checkbox @input="select(content)" v-model="content.active"/>
                    </vs-td>
                    <vs-td>
                        {{ content.advertiser_name || content.advertiser_id }} /
                        {{ content.advertiser_integration_name }}
                    </vs-td>
                    <vs-td>
                        {{ content.geo_name }}
                    </vs-td>
                    <vs-td>
                        {{ content.traffic_model_name }}
                    </vs-td>
                </template>
            </vc-table>

            <div class="mt-4">
                <ValidationProvider vid="teamName" :name="$t('modals.Team_name')"
                                    :rules="{ required: true }"
                                    v-slot="{ errors }">
                    <div class="vs-input--label mb-1">{{ $t('global.Teams') }}</div>
                    <v-select
                        name="teams"
                        appendToBody
                        :disabled="!intList.length"
                        class="w-full"
                        v-model="selectedTeams"
                        :clearable="false"
                        :options="teamsOptions"
                        :placeholder="$t('modals.Choose_team')"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        :calculate-position="withPopper"
                    />
                    <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                </ValidationProvider>
            </div>

            <div class="mt-4 text-right">
                <vs-button @click.prevent="handleSubmit(send)" :disabled="!intList.length || loading" color="primary"
                           type="filled">
                    {{ $t('buttons.Submit') }}
                </vs-button>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import ErrorHandler from '@/utils/errorHandler'
import send from '@/utils/fetch'
import vSelect from 'vue-select'
import EventBus from '@/store/eventBus'
import {vSelectPosition} from "@/utils/mixins"

export default {
    props: ['popupData', 'popupType', 'popupButton'],

    mixins: [vSelectPosition],

    data() {
        return {
            loading: false,
            isSelectedAllIntegrations: false,
            teamIntegrations: [],
            selectedTeams: null,
            intList: [],
            teamsOptions: []
        }
    },

    components: {
        vSelect
    },

    computed: {
        ...mapGetters(['teams']),

        integrations() {
            return this.teamIntegrations
        }
    },

    methods: {
        selectedAllIntegrations() {
            if(this.isSelectedAllIntegrations) {
                this.intList = this.integrations.map(item => item.advertiser_integration_id)
            } else {
                this.intList = []
                this.selectedTeams = null
            }

            this.selectAllIntegrations(this.isSelectedAllIntegrations)
        },

        async getTeamIntegrations() {
            try {
                const response = await send(this.$url.advrtsr_team_integration.get, 'GET', {params: {id: this.popupData.id}})
                    .then(response => response.data.result)

                this.teamIntegrations = response.map(item => ({
                    ...item,
                    active: false
                }))
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        selectAllIntegrations(globalStatus) {
            this.teamIntegrations = this.integrations.map(item => ({
                ...item,
                active: globalStatus
            }))
        },

        select(data) {
            const id = this.intList.find(item => item === data.advertiser_integration_id)

            if(id) {
                this.intList = this.intList.filter(item => item !== id)
            } else {
                this.intList.push(data.advertiser_integration_id)
            }

            this.isSelectedAllIntegrations = this.integrations.length === this.intList.length

            if (!this.intList.length){
                this.selectedTeams = null
            }

        },

        async send() {
            try {
                this.loading = true
                const data = {
                    id: this.popupData.id,
                    integration_ids: this.intList,
                    team_id: this.selectedTeams.value
                }

                const response = await send(this.$url.advrtsr.clone, 'POST', {data})

                for(const id of response.data.result.unsuccessful) {
                    const integration = this.integrations.find(item => item.advertiser_integration_id === id)
                    if(integration) {
                        this.$vs.notify({
                            title: 'Warning',
                            text: `Integration ${integration.advertiser_name}/${integration.advertiser_integration_name} was not copied successfully. Perhaps it already exist in the ${this.teams.label} team`,
                            color: 'warning',
                            iconPack: 'feather',
                            icon: 'icon-alert-triangle',
                            time: 10000
                        })
                    }
                }

                EventBus.$emit('getTeamsInt')
                EventBus.$emit('emitPopupEvent', {type: 'close'})
            } catch (e) {
                new ErrorHandler(e).send
            } finally {
                this.loading = false
            }
        },

        selectTeams() {
            const teams = this.teams.filter(item => item.id !== this.popupData.id)
            this.teamsOptions = teams.map(item => ({
                label: item.name,
                value: item.id
            }))
        }
    },

    async mounted() {
        try {
            await this.getTeamIntegrations()
            this.selectTeams()

            this.$store.commit('UPDATE_LOADER_STATE', false)
        } catch (e) {
            this.$store.commit('UPDATE_LOADER_STATE_SET_ERROR', true)
        }
    }
}
</script>

<style lang="scss">
.copyInt {
    .vs-con-tbody {
        border: none !important;
    }
}
</style>
